import useSidebarRouteActive from "components/Sidebar/hooks/useSidebarRouteActive";
import { useMemo } from "react";
import { RouteItemLink } from "../..";
import { LinkProps } from "react-router-dom";

interface RouteLinkProps extends LinkProps {
  to: string;
  children: React.ReactNode;
}

function RouteLink(props: RouteLinkProps) {
  const { to, children, ...rest } = props;
  const { isRouteActive } = useSidebarRouteActive();

  const isActive = useMemo(() => isRouteActive(to), [isRouteActive, to]);

  return (
    <RouteItemLink to={to} data-active={isActive} aria-current={isActive ? "page" : undefined} {...rest}>
      {children}
    </RouteItemLink>
  );
}

export default RouteLink;
